import React from 'react';
import { FaqLinkToFormDoc } from './components/FAQLinkToFormDoc';

export const FAQData: { sectionName: string; queryItems: { query: string; answer: JSX.Element }[] }[] = [
  {
    sectionName: 'Олимпиады',
    queryItems: [
      {
        query: 'Какой дате соответствует статистика олимпиад?',
        answer: (
          <>
            Чтобы посмотреть дату обновления статистики:
            <br /> <br />
            <ol>
              <li>Перейдите в раздел «Олимпиады» — «Проходят».</li>
              <li>Найдите интересующее вас онлайн-соревнование.</li>
              <li>
                Посмотрите дату рядом с заголовком подраздела «Статистика активности учащихся в школах муниципалитета».
              </li>
            </ol>
          </>
        ),
      },
      {
        query: 'Где посмотреть количество победителей в олимпиадах?',
        answer: (
          <>
            Чтобы узнать результаты соревнований:
            <br /> <br />
            <ol>
              <li>Перейдите в раздел «Олимпиады» — «Завершились».</li>
              <li>Найдите интересующее вас онлайн-соревнование.</li>
              <li>
                Посмотрите количество победителей в сводной таблице подраздела «Статистика активности учащихся в школах
                муниципалитета».
              </li>
            </ol>
          </>
        ),
      },
      {
        query: 'Где посмотреть процент участников олимпиады? ',
        answer: (
          <>
            Для регионов:
            <br /> <br />
            В регионе процент считается от количества активных учеников на платформе Учи.ру. Эти данные доступны на
            главной странице кабинета (только для наиболее крупных соревнований) и в разделе «Олимпиады».
            <br /> <br />
            Для муниципалитетов:
            <br /> <br />В муниципалитете процент считается от количества учащихся в образовательных учреждениях. Эти
            данные доступны на главной странице кабинета и в разделе «Олимпиады».
          </>
        ),
      },
    ],
  },
  {
    sectionName: 'Образовательные учреждения',
    queryItems: [
      {
        query: 'Как изменить название образовательного учреждения?',
        answer: (
          <>
            Для этого необходимо оставить обращение через форму обратной связи, расположенную в правом нижнем углу на
            всех страницах кабинета:
            <br /> <br />
            <ul>
              <li>Укажите свои контактные данные и название организации, которое нужно переименовать.</li>
              <li>
                При необходимости приложите документы, например, файл Excel с актуальным списком образовательных
                учреждений. В нем должны быть указаны населенный пункт, полное и сокращенное название организации, ее
                тип и количество учеников (<FaqLinkToFormDoc />
                ).
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
          </>
        ),
      },
      {
        query: 'Как добавить новое образовательное учреждение для отображения в статистике?',
        answer: (
          <>
            Для этого необходимо оставить обращение через форму обратной связи, расположенную в правом нижнем углу на
            всех страницах кабинета:
            <br /> <br />
            <ul>
              <li>Укажите свои контактные данные и название организации, которое нужно добавить.</li>
              <li>
                При необходимости приложите документы, например, файл Excel с актуальным списком образовательных
                учреждений. В нем должны быть указаны населенный пункт, полное и сокращенное название организации, ее
                тип и количество учеников (<FaqLinkToFormDoc />
                ).
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
          </>
        ),
      },
      {
        query: 'Можно ли смотреть статистику по типу учреждения (школы, детские сады и т.д.)?',
        answer: (
          <>
            Сейчас в кабинете такой возможности нет. При выгрузке статистики вы можете самостоятельно удалить из файла
            ненужные учреждения.
          </>
        ),
      },
      {
        query:
          'Как добавить точные данные по количеству учащихся в образовательных учреждениях, если процент участников олимпиады некорректный? ',
        answer: (
          <>
            Для регионов:
            <br /> <br />
            Добавить данные по количеству учащихся или изменить число активных учеников невозможно по техническим
            причинам. Если вы заметили, что процент участников олимпиад отображается некорректно, подождите два дня,
            пока не появится актуальная информация. Если показатели останутся прежними, вы можете обратиться к нам:
            оставьте обращение через форму обратной связи, расположенную в правом нижнем углу на всех страницах
            кабинета:
            <br />
            <br />
            <ul>
              <li>Укажите свои контактные данные и опишите проблему.</li>
              <li>
                При необходимости приложите документы, например, фото экрана с отображением некорректной информации.
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
            <br /> <br />
            Для муниципалитетов:
            <br /> <br />
            Если вы заметили, что процент участников олимпиад некорректный, подождите два дня, пока информация не
            обновится. Если показатели останутся прежними, вы можете передать нам точные данные по количеству учеников в
            учреждениях для перерасчета. Для этого необходимо оставить обращение через форму обратной связи,
            расположенную в правом нижнем углу на всех страницах кабинета:
            <br /> <br />
            <ul>
              <li>Укажите свою контактную информацию и опишите проблему. </li>
              <li>
                При необходимости приложите документы, например, фото экрана с отображением некорректных данных или файл
                Excel с актуальным списком образовательных учреждений, в котором будут указаны населенный пункт, полное
                и сокращенное название организации, ее тип и количество учеников (<FaqLinkToFormDoc />
                ).
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
          </>
        ),
      },
      {
        query: 'Как перенести образовательное учреждение в другой муниципалитет? ',
        answer: (
          <>
            Для этого необходимо оставить обращение через форму обратной связи, расположенную в правом нижнем углу на
            всех страницах кабинета:
            <br /> <br />
            <ul>
              <li>
                Укажите свои контактные данные и информацию об организации, которую нужно перенести в другой
                муниципалитет.
              </li>
              <li>
                При необходимости приложите документы, например, файл Excel с актуальным списком образовательных
                учреждений. В нем должны быть указаны: населенный пункт, полное и сокращенное название организации, ее
                тип и количество учеников (<FaqLinkToFormDoc />
                ).
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
          </>
        ),
      },
      {
        query: 'Как изменить данные по количеству учеников в образовательном учреждении? ',
        answer: (
          <>
            Обратите внимание: эта информация доступна только в кабинете муниципалитета. Чтобы актуализировать данные по
            количеству учеников, необходимо оставить обращение через форму обратной связи, расположенную в правом нижнем
            углу на всех страницах кабинета:
            <br /> <br />
            <ul>
              <li>Укажите свои контактные данные и напишите, какую информацию нужно изменить.</li>
              <li>
                При необходимости приложите документы, например, файл Excel с актуальным списком образовательных
                учреждений. В нем должны быть указаны: населенный пункт, полное и сокращенное название организации, ее
                тип и количество учеников (<FaqLinkToFormDoc /> ).
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
          </>
        ),
      },
      {
        query: 'Как обновить информацию об учреждении, если его реорганизовали или ликвидировали?',
        answer: (
          <>
            Для этого необходимо оставить обращение через форму обратной связи, расположенную в правом нижнем углу на
            всех страницах кабинета:
            <br /> <br />
            <ul>
              <li>
                Укажите свои контактные данные и напишите, какую информацию в конкретных организациях нужно обновить или
                удалить.
              </li>
              <li>
                При необходимости приложите документы, например, файл Excel с актуальным списком образовательных
                учреждений. В нем должны быть указаны: населенный пункт, полное и сокращенное название организации, ее
                тип и количество учеников (<FaqLinkToFormDoc />
                ).
              </li>
              <li>Перед загрузкой убедитесь, что файлы соответствуют требованиям.</li>
            </ul>
            <br />
            После отправки обращения с вами свяжется команда развития кабинета региона и муниципалитета или ваш
            менеджер.
          </>
        ),
      },
    ],
  },
  {
    sectionName: 'КПК',
    queryItems: [
      {
        query: 'Где посмотреть статистику участия педагогов в курсах повышения квалификации? ',
        answer: (
          <>
            Сейчас в кабинете такой информации нет. Вы можете запросить статистику у персонального менеджера, его
            контакты указаны в меню слева внизу.
          </>
        ),
      },
    ],
  },
];
